const l = {
  name: "Pencil",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13.7,27.7l21-21l-1.4-1.4l-21,21L13.7,27.7z"/>
		<path class="st0" d="M4.5,25.1L0.2,36.4l0,0C0.1,36.7,0,37,0,37.3C0,38.8,1.2,40,2.7,40c0.3,0,0.7-0.1,0.9-0.2l11.3-4.3l22.9-22.9
			c1.4-1.4,2.2-3.3,2.2-5.2c0-2-0.8-3.9-2.1-5.2l0,0C36.5,0.8,34.6,0,32.6,0c-2,0-3.8,0.8-5.2,2.2L4.5,25.1z M32.6,2
			c1.4,0,2.8,0.6,3.8,1.6c1,1,1.6,2.3,1.6,3.8c0,1.4-0.6,2.8-1.6,3.8L15,32.6L7.4,25L28.8,3.6C29.8,2.6,31.2,2,32.6,2z M4.1,31.7
			l2-5.2l7.4,7.4l-5.2,2L4.1,31.7z M3.3,33.7l2.9,2.9L2.9,38c-0.1,0-0.2,0-0.2,0C2.3,38,2,37.7,2,37.3c0-0.1,0-0.2,0-0.2L3.3,33.7z"
			/>
	</g>
</g>
</svg>
  `
};
export {
  l as Pencil
};
